import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { CoreService } from 'src/app/services/core.service';

@Component({
  selector: 'app-branding',
  standalone: true,
  imports: [NgIf],
  template: `
  <div class="branding">
  <a href="/dashboards" *ngIf="options.theme === 'light'">
    <img
      src="./assets/images/logos/dark-logo.png"
      style="width: 10rem;"
      alt="logo"
    />
  </a>
  <a href="/dashboards" *ngIf="options.theme === 'dark'">
    <img
      src="./assets/images/logos/light-logo.png"
      style="width: 11rem;"
      alt="logo"
    />
  </a>
</div>
  `,
})
export class BrandingComponent {
  options = this.settings.getOptions();
 
  constructor(private settings: CoreService) {}
}
